/* eslint-disable sort-keys */

export var getTabStyles = function getTabStyles(theme, current) {
  return {
    buttonPrimary: {
      "false": {
        bg: 'transparent',
        label: theme.palette.gray[500],
        badge: 'gray'
      },
      "true": {
        bg: theme.palette.primary[50],
        label: theme.palette.primary[700],
        badge: 'primary'
      },
      hover: {
        bg: theme.palette.primary[50],
        label: theme.palette.primary[700],
        badge: 'primary'
      },
      focus: {
        bg: current ? theme.palette.primary[50] : theme.palette.common.white,
        label: current ? theme.palette.primary[700] : theme.palette.gray[500],
        badge: 'gray',
        shadow: "0 0 0 4px ".concat(theme.palette.primary[100])
      }
    },
    buttonPrimaryBorder: {
      "false": {
        bg: 'transparent',
        label: theme.palette.gray[500],
        badge: 'gray'
      },
      "true": {
        bg: theme.palette.primary[50],
        border: "1px solid ".concat(theme.palette.primary[100]),
        label: theme.palette.primary[700],
        badge: 'primary'
      },
      hover: {
        bg: theme.palette.primary[50],
        label: theme.palette.primary[700],
        border: "1px solid ".concat(theme.palette.primary[100]),
        badge: 'primary'
      },
      focus: {
        bg: current ? theme.palette.primary[50] : theme.palette.common.white,
        label: current ? theme.palette.primary[700] : theme.palette.gray[500],
        badge: 'gray',
        shadow: "0 0 0 4px ".concat(theme.palette.primary[100])
      }
    },
    buttonGray: {
      "false": {
        bg: 'transparent',
        label: theme.palette.gray[500],
        badge: 'gray'
      },
      "true": {
        bg: theme.palette.gray[50],
        label: theme.palette.gray[700],
        badge: 'gray'
      },
      hover: {
        bg: theme.palette.gray[50],
        label: theme.palette.gray[700],
        badge: 'gray'
      },
      focus: {
        bg: current ? theme.palette.gray[50] : theme.palette.common.white,
        label: current ? theme.palette.gray[700] : theme.palette.gray[500],
        badge: 'gray',
        shadow: "0 0 0 4px ".concat(theme.palette.gray[100])
      }
    },
    buttonWhiteBorder: {
      "false": {
        bg: 'transparent',
        label: theme.palette.gray[500],
        badge: 'gray'
      },
      "true": {
        bg: theme.palette.common.white,
        label: theme.palette.gray[700],
        badge: 'gray',
        shadow: theme.shadows[2]
      },
      hover: {
        bg: theme.palette.common.white,
        label: theme.palette.gray[700],
        badge: 'gray',
        shadow: theme.shadows[2]
      },
      focus: {
        bg: theme.palette.common.white,
        label: current ? theme.palette.gray[700] : theme.palette.gray[500],
        badge: 'gray',
        shadow: "0 0 0 4px ".concat(theme.palette.gray[100])
      }
    },
    underline: {
      "false": {
        bg: 'transparent',
        label: theme.palette.gray[500],
        badge: 'gray',
        borderBottom: '2px solid transparent'
      },
      "true": {
        bg: 'transparent',
        label: theme.palette.primary[700],
        badge: 'primary',
        borderBottom: "2px solid ".concat(theme.palette.primary[700])
      },
      hover: {
        bg: 'transparent',
        label: theme.palette.primary[700],
        badge: 'primary',
        borderBottom: "2px solid ".concat(theme.palette.primary[700])
      },
      focus: {
        bg: 'transparent',
        label: theme.palette.primary[700],
        badge: 'primary',
        borderBottom: "2px solid ".concat(theme.palette.primary[700])
      }
    },
    underlineFilled: {
      "false": {
        bg: 'transparent',
        label: theme.palette.gray[500],
        badge: 'gray',
        borderBottom: '2px solid transparent'
      },
      "true": {
        bg: theme.palette.primary[50],
        label: theme.palette.primary[700],
        badge: 'primary',
        borderBottom: "2px solid ".concat(theme.palette.primary[700])
      },
      hover: {
        bg: theme.palette.primary[50],
        label: theme.palette.primary[700],
        badge: 'primary',
        borderBottom: "2px solid ".concat(theme.palette.primary[700])
      },
      focus: {
        bg: theme.palette.primary[50],
        label: theme.palette.primary[700],
        badge: 'primary',
        borderBottom: "2px solid ".concat(theme.palette.primary[700])
      }
    },
    lineVertical: {
      "false": {
        bg: 'transparent',
        label: theme.palette.gray[500],
        badge: 'gray'
      },
      "true": {
        bg: 'transparent',
        label: theme.palette.primary[700],
        badge: 'primary',
        borderLeft: "2px solid ".concat(theme.palette.primary[700])
      },
      hover: {
        bg: 'transparent',
        label: theme.palette.primary[700],
        badge: 'primary',
        borderLeft: "2px solid ".concat(theme.palette.primary[700])
      },
      focus: {
        bg: 'transparent',
        label: theme.palette.primary[700],
        badge: 'primary',
        borderLeft: "2px solid ".concat(theme.palette.primary[700])
      }
    }
  };
};